import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { catchError, Observable, of, shareReplay, Subject, takeUntil } from 'rxjs';
import { AccountService } from '../../api-services/user-mgt/services/account.service';
import { ISubUser } from '../../api-services/user-mgt/models/account.model';
import { ResponseModel } from '../../interfaces/response-model';
import { AlertType, SweetAlertService } from '../../Utilities/sweet-alert.service';

@Component({
  selector: 'app-sub-users-section',
  templateUrl: './sub-users-section.component.html'
})
export class SubUsersSectionComponent implements OnInit, OnDestroy {

  @Input() userId: string;

  subUsers$: Observable<ResponseModel<ISubUser[]>>;
  private destroy$ = new Subject<void>();

  constructor(
    private _accountService: AccountService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.getSubUsers();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSubUsers(): void {
    this.subUsers$ = this._accountService.getSubUsers(this.userId).pipe(
      takeUntil(this.destroy$),
      catchError((error) => {
        this.sweetAlertService.showAlert(
          error?.error?.message || 'Failed to load sub-users, please try again',
          AlertType.Error
        );
        return of({ data: [] } as any);
      }),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }
}
